import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import organisationReducer from './organisationReducer';

export default combineReducers({
    toastr: toastrReducer,
    organisation: organisationReducer
});
